import { render, staticRenderFns } from "./add-details.vue?vue&type=template&id=310925a2&scoped=true&"
import script from "./add-details.vue?vue&type=script&lang=ts&"
export * from "./add-details.vue?vue&type=script&lang=ts&"
import style0 from "./add-details.vue?vue&type=style&index=0&id=310925a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310925a2",
  null
  
)

export default component.exports